// extracted by mini-css-extract-plugin
export var outlined = "Button-module--outlined--ab9fd";
export var white = "Button-module--white--98699";